import { Refresh } from "@mui/icons-material";
import { Snackbar, Theme } from "@mui/material";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import React from "react";
import clsx from "clsx";

export interface SnackbarProps {
    open: boolean;
    message?: string;
    severity?: "error" | "success";
    onRetry?: () => void;
    onClose?: () => void;
    onClick?: () => void;
    autoHideDurationInSec?: number;
    testId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    actionButton: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    actionButtonIcon: {
        color: theme.palette.primary.contrastText,
        marginRight: "0.5rem"
    },
    alert: {
        minWidth: "480px"
    },
    alertClickable: {
        cursor: "pointer"
    },
    message: {
        whiteSpace: "pre-wrap",
        // The following lines limit the number of lines to 2 and add an ellipsis if the text is too long.
        // The -webkit- prefixes are required for it to work. Works at least on Chrome and Firefox.
        display: "-webkit-box",
        "-webkit-line-clamp": 2,
        "-webkit-box-orient": "vertical",
        overflow: "hidden"
    }
}));

export const CustomSnackbar: React.FC<SnackbarProps> = props => {
    const classes = useStyles();

    const {
        open,
        onRetry,
        message,
        testId,
        severity,
        onClose,
        autoHideDurationInSec,
        onClick
    } = props;

    return (
        <Snackbar
            open={open}
            key={testId}
            onClick={onClick ? () => {
                onClick();
                onClose?.();
            } : undefined}
            onClose={(e, reason) => {
                if (reason === "timeout" && onClose) {
                    onClose();
                }
            }}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            disableWindowBlurListener
            autoHideDuration={autoHideDurationInSec ? autoHideDurationInSec * 1000 : undefined}>

            <Alert
                data-cy={`${props.testId}-Alert-${severity}`}
                variant="filled"
                icon={false}
                className={clsx(classes.alert, onClick && classes.alertClickable)}
                elevation={4}
                severity={severity}
                action={onRetry ? (
                    <IconButton
                        disableRipple
                        disableFocusRipple
                        disableTouchRipple
                        className={classes.actionButton}
                        size="small"
                        onClick={onRetry}>
                        <Refresh className={classes.actionButtonIcon} />
                    </IconButton>
                ) : undefined}>

                <span className={classes.message}>
                    {message}
                </span>

            </Alert>
        </Snackbar>
    );
};
